import React, { Fragment, useState, useEffect } from "react";
import Header from "../common/header";
import Footer from "../common/footer";
import CareerInnerBanner from "./career-inner-banner";
import CareerInnerDescription from "./career-inner-description";
import { useParams } from "react-router-dom";

import * as apiUrl from "../../apiUrl";

import logo from "../../assets/marquis-logo.svg";

function CareerInnerPage() {
  const { slug } = useParams();
  const [job, setJob] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchJob = async () => {
      try {
        const response = await fetch(
          apiUrl.apiUrl + `/api/careers/job-description/${slug}`
        );
        if (!response.ok) {
          throw new Error("Job not found");
        }
        const data = await response.json();
        setJob(data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching Job:", error);
        setLoading(false);
      }
    };

    fetchJob();
  }, [slug]);

  if (loading) {
    return (
      <div className="loading-container">
        <img src={logo} alt="Loading" className="loading-logo" />
      </div>
    );
  }

  if (!job) {
    return <p>Job not found.</p>;
  }

  return (
    <Fragment>
      <Header />
      <CareerInnerBanner />
      <CareerInnerDescription title={job.title} description={job.description} />
      <Footer />
    </Fragment>
  );
}
export default CareerInnerPage;
